import moment from "moment";
import { WfPerformacne } from "src/app/model/wf-performacne.model";

export class WorkflowDataSorter {
  dataSource: WfPerformacne[];
  column: string;
  asc: boolean;

  sort() {
    if (this.dataSource && this.column) {
      this.dataSource = this.dataSource.slice().sort((a: WfPerformacne, b: WfPerformacne) => this.compare(a, b));
    }
    return this.dataSource;
  }

  compare(a: WfPerformacne, b: WfPerformacne): number {
    let x, y;

    if (this.column == 'avgDuration') {
      [x, y] = this.time(a, b);
    } else {
      x = (<any>a)[this.column]
      y = (<any>b)[this.column]
    }

    if (x == y || !(x && y)) {
      return 0;
    }
    else {
      return ((x < y ? -1 : 1) * (this.asc ? 1 : -1))
    };
  }

  time(a: any, b: any) {
    let aTime = moment(a[this.column]).toDate().getTime();
    let bTime = moment(b[this.column]).toDate().getTime();
    return [aTime, bTime]
  }
}
